export const isInputActive = () => {
  const activeElement = document.activeElement

  return activeElement?.tagName === 'INPUT' || activeElement?.tagName === 'TEXTAREA' || activeElement?.tagName === 'SELECT'
}
